import { ProfilePhoto } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/profile/v1/profile_pb';

import { showNotification } from '@/components/notification/helpers/notification-shower/notification-shower';
import { pushRoute } from '@/router';
import { useI18n } from '@/services/i18n';
import { ExtractClassFields } from '@/type';

import { messages } from './i18n';

export async function notificationAstroCompatibilityPromo(
  userId: string,
  avatar: ExtractClassFields<ProfilePhoto>,
): Promise<void> {
  const photoId = avatar?.id;
  const { t } = useI18n({ messages });

  showNotification({
    type: 'mutual-activity',
    category: 'astro',
    photoId,
    isLocked: true,
    avatarForm: 'square',
    header: t('header'),
    description: t('description'),
    actionText: t('action'),
    iconName: 'stars',
    action: {
      click: () => {
        pushRoute('profileView', { userId, scroll: 'astro' });
      },
    },
  });
}
